// NVBDC-1404 plan item 17 — shared business-rule constant consumed by both UI trees, so a future
// change (new certification type, changed label) is a compile-time-visible single edit instead of
// two hand-maintained lists silently drifting apart. Field names/labels mirror the classic wizard's
// steps/businessCertifications/BusinessCertifications.js exactly (source of truth for what these
// certifications are) — only the presentation (Switch pill vs. CheckBox) differs on the one-sheet.
const BUSINESS_CERTIFICATION_TYPES = [
    { field: 'nmsdc', label: 'NMSDC — National Minority Supplier Development Council', hasExpiration: true, hasFile: true },
    { field: 'wbenc', label: 'WBENC — Women’s Business Enterprise National Council', hasExpiration: true, hasFile: true },
    { field: 'nglcc', label: 'NGLCC — National Gay & Lesbian Chamber of Commerce', hasExpiration: true, hasFile: true },
    { field: 'cve', label: 'CVE — Veterans Administration', hasExpiration: false, hasFile: false },
    { field: 'sba8', label: 'SBA — 8(a) Socially and Economically Disadvantaged', hasExpiration: false, hasFile: false },
    { field: 'sba', label: 'SBA — HUBZone', hasExpiration: false, hasFile: false },
    { field: 'dvbe', label: 'DVBE — Disabled Veterans Business Enterprise', hasExpiration: false, hasFile: false },
    { field: 'naVOBA', label: 'NaVOBA — National Veteran-Owned Business Association', hasExpiration: false, hasFile: false },
    { field: 'di', label: 'DI — DisabilityIN', hasExpiration: false, hasFile: false }
];

export default BUSINESS_CERTIFICATION_TYPES;



// WEBPACK FOOTER //
// ./src/areas/certification/shared/BusinessCertificationTypes.js